


















































import { defineComponent, ref, PropType, inject } from "@vue/composition-api";
import { useState } from "@/compositions/useNodeState";
import { NodeDaoInjectionKey } from "@/domain/nodes";
import { AliasDaoInjectionKey } from "@/domain/alias";

export default defineComponent({
  props: {
    currentRoute: {
      type: String as PropType<string>,
      default: ""
    }
  },
  setup(_, { emit }) {
    const nodeDao = inject(NodeDaoInjectionKey);
    const aliasDao = inject(AliasDaoInjectionKey);
    if (!nodeDao || !aliasDao) {
      throw new Error("Dao is not injected");
    }
    const { addNewPath, allRoute } = useState(nodeDao, aliasDao);
    const newPath = ref("");
    const createRoute = () => {
      addNewPath(newPath.value);
      newPath.value = "";
    };
    return {
      newPath,
      addNewPath,
      allRoute,
      createRoute,
      emit
    };
  }
});
